<script setup>
import HeadingTwo from '@/Components/HeadingTwo.vue'
import Paragraph from '@/Components/Paragraph.vue'
</script>

<template>
    <div class="section--width">
        <div class="card relative isolate overflow-hidden text-center">
            <HeadingTwo
                class="!mt-0"
                value="Pomůžeme Vám!"
            />

            <Paragraph>
                Nestihli jste podat daňové přiznání? Nebojte se, my Vám pomůžeme. Stačí nám poslat potřebné dokumenty a my se postaráme o
                zbytek, včetně podání daňového přiznání.
            </Paragraph>

            <div class="mt-10 flex items-center justify-center gap-x-6">
                <Link
                    :href="route('orders.create')"
                    aria-label="Objednat službu"
                    class="relative flex items-center rounded-lg border border-cyan-300 bg-cyan-600 px-4 py-2"
                >
                    <span class="text-sm font-medium text-white transition-colors duration-200 sm:text-base">
                        Podat přiznání za rok {{ new Date().getFullYear() - 1 }}
                    </span>
                </Link>
            </div>
        </div>
    </div>
</template>
